export const defaultState = {
  id: null,
  description: '',
  files: [],
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    switch (action.payload.dataType) {
      case 'file':
        return {
          ...state,
          files: action.payload.value === null
            ? []
            : Array.isArray(action.payload.value)
              ? action.payload.value
              : [action.payload.value],
        };
      default:
        return { ...state, [action.payload.name]: action.payload.value };
    }
  }

  return state;
}
